import React,{useEffect} from "react";
import {NavLink} from 'react-router-dom'
import { useAappContext } from "../context/AppContext";

const Description = ()=>{
    const {getAvansisData,Avansis,getApiHost,ApiHost}= useAappContext();
    const {getWellcomMsg,wellcomMsg:WelcomMsg} = useAappContext();
    useEffect(() => {
        getAvansisData('/avasisbd/')
        getWellcomMsg()
        getApiHost()
    }, [])
  
    return(
        <section id="description" className="section-p1 section-m1">
          <div className="images">
          {
                WelcomMsg.map((imagess)=>{
                    const {image,id}=imagess;
                    return (
                    <div key={id} >
                       {image ? <img  src={ApiHost+image} alt="img"/> : ''} 
                    </div>
                    )
                })
            }
          </div>
                       
        <div className="descripton-1">
            <h4>WELCOME TO</h4>
            {
                Avansis.map((avansis)=>{
                    return <h1 key={avansis.id}>{avansis.name}</h1>

                })
            }
            <br/>
                <h3> Dear Customer!</h3>
            
                {
                WelcomMsg.map((msg)=>{
                    const {para_id,para}=msg;
                    return <div key={para_id} className="para" >
                        <p>{para}</p>
                    </div>
                    
                })
                
                }
            <p>Yours sincerely!</p>
            {
                Avansis.map((avansis)=>{
                    return <span key={avansis.id} className="cname">{avansis.name}</span>

                })
            }
          
            <h3>Secure - Trustful</h3>
            <NavLink to={'/aboutus/'}><button className="normal">detail</button></NavLink> 
        </div>
    </section>
    )


}
export default Description;


   